import { atom } from 'jotai';

const statusesAtom = atom([]);

export {
  statusesAtom,
};
